import { Box, Typography } from "@mui/material";
import MobileHeader from "./headers/MobileHearder";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

export default function BillingMobile() {
  const { translate } = useContext(LanguageContext);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <MobileHeader title={translate("Billing")} />
      <Box sx={{ p: 2, pt: 4 }}>
        <Typography variant="body1" sx={{ opacity: 0.8 }}>
          {translate("BillingPagePlaceholder") ||
            "Billing details and credits will appear here."}
        </Typography>
      </Box>
    </Box>
  );
}
